export default function CTABanner() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      {/* Background image */}
      <img
        src="https://static.readdy.ai/image/36fff7c058435a92029a1d7ae462693c/17858b38b883322458aac9632e19dec1.jpeg"
        alt="HVAC service"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-[#0B2447]/80"></div>
      {/* Orange side accent */}
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C8102E]"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-5 md:px-10 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex-1 text-center md:text-left">
          <span className="text-[#C8102E] text-xs font-bold tracking-[0.2em] uppercase">READY TO HELP</span>
          <h2 className="text-2xl md:text-4xl font-extrabold text-white mt-3 mb-4 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Your Comfort Can&apos;t Wait.
          </h2>
          <p className="text-white/70 text-sm leading-relaxed max-w-lg mx-auto md:mx-0">
            Broken furnace? AC out in July? Our certified technicians are dispatched fast — most appointments are same or next day. Call now or submit a request online.
          </p>
        </div>
        <div className="flex flex-col gap-3 w-full md:w-auto md:flex-shrink-0">
          <a
            href="#contact"
            className="bg-[#C8102E] text-white font-bold text-sm px-10 py-3.5 rounded-full hover:bg-[#A8091D] transition-colors cursor-pointer whitespace-nowrap text-center"
          >
            BOOK A TECHNICIAN
          </a>
          <a
            href="tel:9592418524"
            className="border-2 border-white/40 text-white font-bold text-sm px-10 py-3.5 rounded-full hover:bg-white/10 hover:border-white transition-colors cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
          >
            <i className="ri-phone-fill"></i> (959)241-8524
          </a>
        </div>
      </div>
    </section>
  );
}
